var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3998 5.38079L1.8098 0.790792C1.62244 0.604542 1.36899 0.5 1.1048 0.5C0.840616 0.5 0.587165 0.604542 0.399802 0.790792C0.306074 0.883756 0.23168 0.994357 0.180911 1.11622C0.130142 1.23808 0.104004 1.36878 0.104004 1.50079C0.104004 1.6328 0.130142 1.76351 0.180911 1.88537C0.23168 2.00723 0.306074 2.11783 0.399802 2.21079L4.9998 6.79079C5.09353 6.88376 5.16793 6.99436 5.21869 7.11622C5.26946 7.23808 5.2956 7.36878 5.2956 7.50079C5.2956 7.63281 5.26946 7.76351 5.21869 7.88537C5.16793 8.00723 5.09353 8.11783 4.9998 8.21079L0.399802 12.7908C0.211499 12.9778 0.105184 13.2319 0.104246 13.4973C0.103308 13.7626 0.207825 14.0175 0.394803 14.2058C0.581781 14.3941 0.835903 14.5004 1.10127 14.5014C1.36663 14.5023 1.6215 14.3978 1.8098 14.2108L6.3998 9.62079C6.96161 9.05829 7.27716 8.2958 7.27716 7.50079C7.27716 6.70579 6.96161 5.94329 6.3998 5.38079Z",
    fill: "url(#paint0_linear_1324_3230)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1324_3230",
    x1: 3.69058,
    y1: 0.5,
    x2: 3.69058,
    y2: 14.5014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleLeft);
export default __webpack_public_path__ + "static/media/angle-left.d261537d7afa7af38b13fa4eea924c6c.svg";
export { ForwardRef as ReactComponent };